<template>
  <el-dialog
    :title="$t('reportCustomComponentManage.add')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form
      ref="addForm"
      :model="addReportCustomComponentInfo"
      label-width="120px"
      label-position="right"
    >
      <el-form-item
        :label="$t('reportCustomComponentManage.componentName')"
        prop="name"
        :rules="[
          { required: true, message: $t('reportCustomComponentManage.requiredComponentName'), trigger: 'blur' },
          { max: 64, message: $t('reportCustomComponentManage.maxLength64'), trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="addReportCustomComponentInfo.name"
          :placeholder="$t('reportCustomComponentManage.inputComponentName')"
          style="width:100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('reportCustomComponentManage.componentType')"
        prop="componentType"
        :rules="[
          { required: true, message: $t('reportCustomComponentManage.requiredComponentType'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="addReportCustomComponentInfo.componentType"
          :placeholder="$t('reportCustomComponentManage.selectComponentType')"
          style="width:100%"
        >
          <el-option
            v-for="item in componentTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('reportCustomComponentManage.queryMethod')"
        prop="queryModel"
        :rules="[
          { required: true, message: $t('reportCustomComponentManage.requiredQueryMethod'), trigger: 'change' }
        ]"
      >
        <el-select
          v-model="addReportCustomComponentInfo.queryModel"
          :placeholder="$t('reportCustomComponentManage.selectQueryMethod')"
          style="width:100%"
        >
          <el-option label="sql" value="1" />
          <el-option label="java" value="2" />
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="addReportCustomComponentInfo.queryModel === '1'"
        label="sql"
      >
        <el-input
          v-model="addReportCustomComponentInfo.componentSql"
          type="textarea"
          :rows="15"
          :placeholder="$t('reportCustomComponentManage.inputSql')"
          style="width:100%"
        />
      </el-form-item>

      <el-form-item
        v-if="addReportCustomComponentInfo.queryModel === '2'"
        label="java"
      >
        <el-input
          v-model="addReportCustomComponentInfo.javaScript"
          type="textarea"
          :rows="15"
          :placeholder="$t('reportCustomComponentManage.inputJavaScript')"
          style="width:100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('reportCustomComponentManage.description')"
      >
        <el-input
          v-model="addReportCustomComponentInfo.remark"
          type="textarea"
          :placeholder="$t('reportCustomComponentManage.inputDescription')"
          style="width:100%"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveReportCustomComponentInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveReportCustomComponent } from '@/api/dev/reportCustomComponentApi'

export default {
  name: 'AddReportCustomComponent',
  data() {
    return {
      dialogVisible: false,
      addReportCustomComponentInfo: {
        name: '',
        componentType: '',
        queryModel: '',
        componentSql: '',
        javaScript: '',
        remark: ''
      },
      componentTypeOptions: [
        { value: '1001', label: this.$t('reportCustomComponentManage.table') },
        { value: '2002', label: this.$t('reportCustomComponentManage.pieChart') }
      ]
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addReportCustomComponentInfo = {
        name: '',
        componentType: '',
        queryModel: '',
        componentSql: '',
        javaScript: '',
        remark: ''
      }
    },
    async saveReportCustomComponentInfo() {
      this.$refs.addForm.validate(async valid => {
        if (!valid) return

        try {
          await saveReportCustomComponent(this.addReportCustomComponentInfo)
          this.$message.success(this.$t('reportCustomComponentManage.addSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error(error)
        }
      })
    }
  }
}
</script>